var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
export var GoogleAnalyticsElement = function (_a) {
    var children = _a.children, event = _a.event;
    var handleClick = function (e) {
        if (window.dataLayer && event) {
            window.dataLayer.push({ event: event });
        }
        if (children.props.onClick) {
            children.props.onClick(e);
        }
    };
    return React.cloneElement(children, __assign(__assign({}, children.props), { onClick: handleClick }));
};
